import React, { Component } from 'react';
import { ProfileAvatar } from '../../ProfileAvatar/ProfileAvatar';
import { config } from '../../../../Configurations';
import { RowName, CheckInRow as Row, CheckInButton, CheckedInButton, DisabledCheckInButton } from './style';
import { Text } from '../../../UI/Text';
import './style.css';

const RenderButtons = ({
    memberRow,
    availableSpaces,
    isChecked,
    id,
    onCheckIn,
    onCheckOut,
    bookers,
    memberships,
    gymInfo,
    index,
}) => {
    let isBooker = false;
    let isUserAssignedToPlan = false;
    let planMemberId = null;

    if (memberships && memberships.length > 0 && memberships[0].planMembers.length > 0) {
        planMemberId = memberships[0].planMembers[0].id;
        isUserAssignedToPlan = true;
    }

    if (memberRow) {
        bookers.forEach(booker => {
            if (booker.id === id) isBooker = true;
        });

        if (!isUserAssignedToPlan) return <HoverState position={index} gymName={gymInfo.fullName} />;

        if (!availableSpaces && !isChecked && !isBooker)
            return <DisabledCheckInButton disabled={true}>Class full</DisabledCheckInButton>;
    }

    return isChecked ? (
        <CheckedInButton
            onClick={() => {
                onCheckOut(id, planMemberId);
            }}
        >
            Checked in
        </CheckedInButton>
    ) : (
        <CheckInButton
            onClick={() => {
                onCheckIn(id, planMemberId);
            }}
        >
            Check in
        </CheckInButton>
    );
};

class CheckInRow extends Component {
    render() {
        const { fullName, smallImage } = this.props;

        return (
            <Row>
                <ProfileAvatar size={'medium'} src={`${config.baseUrl}/${smallImage}`} />
                <RowName>
                    <Text marginLeft={'15px'} weight={'bold'}>
                        {fullName}
                    </Text>
                </RowName>
                <RenderButtons {...this.props} />
            </Row>
        );
    }
}

const HoverState = ({ gymName, position }) => (
    <div className={'check-in-user-hover-container'}>
        <DisabledCheckInButton disabled={true}>Check in</DisabledCheckInButton>
        <div className={`check-in-user-tooltip-container ${position === 0 && 'from-bottom'}`}>
            <div className={'check-in-user-tooltip-body'}>
                <Text color={'black'} weight={'bold'} marginBottom={'8px'}>
                    Unable to check in
                </Text>
                <Text lineHeight={1.42} alignCenter={true} weight={100} fontSize={12} color={'grey'}>
                    Check membership type or talk to {gymName} staff to check in to this class.
                </Text>
            </div>
            <div className={position === 0 ? 'check-in-user-tooltip-top' : 'check-in-user-tooltip-bottom'} />
        </div>
    </div>
);

export default CheckInRow;



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/CheckInRow/index.js